import type { QueryResult } from '@flowqa/shared';

export const upsertIntoResult = <T extends { id: string }>(
  prev: QueryResult<T> | undefined,
  item: T,
): QueryResult<T> => {
  if (!prev) {
    return { items: [item], total: 1, page: 1, pageSize: 50 };
  }
  const items = [item, ...prev.items.filter((existing) => existing.id !== item.id)];
  return { ...prev, items, total: Math.max(prev.total, items.length) };
};

export const removeFromResult = <T extends { id: string }>(
  prev: QueryResult<T> | undefined,
  id: string,
): QueryResult<T> | undefined => {
  if (!prev) return prev;
  const items = prev.items.filter((existing) => existing.id !== id);
  return { ...prev, items, total: Math.max(0, prev.total - 1) };
};
